import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';
import Partners from 'components/NextconLabPartners/Partners';

function Fpartners() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Partners/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Partners/>
        <Footer />
      </>
    )}
    </>
  );
}

export default Fpartners;
